export interface WorkflowInstanceDTO {
  id: string;
  definitionId: string;
  definitionVersionId: string;
  definitionVersion: WorkflowInstanceDefinitionVersion;
  version: number;
  status: number;
  subStatus: number;
  correlationId: string;
  name: string;
  incidentCount: number;
  hasFaultedState: boolean;
  createdAt: string;
  updatedAt: string;
  finishedAt: string;
}
export class WorkflowInstance {
  id: string;
  definitionId: string;
  definitionVersionId: string;
  definitionVersion: WorkflowInstanceDefinitionVersion;
  version: number;
  status: string;
  subStatus: string;
  correlationId: string;
  name: string;
  incidentCount: number;
  hasFaultedState: boolean;
  createdAt: string;
  updatedAt: string;
  finishedAt: string;
  constructor(data?: WorkflowInstanceDTO) {
    Object.assign(this, data);
    this.status = WorkflowStatus[data.status].toString();
    this.subStatus = WorkflowSubStatus[data.subStatus].toString();
  }
}

export class WorkflowInstanceDefinitionVersion {
  id: string;
  definitionId: string;
  name: string;
  description: string;
  createdAt: string;
  version: number;
  isReadonly: boolean;
  isSystem: boolean;
  isLatest: boolean;
  isPublished: boolean;
}

export enum WorkflowStatus {
  Running = 0,
  Finished,
}

export enum WorkflowSubStatus {
  Pending = 0,
  Executing,
  Suspended,
  Finished,
  Cancelled,
  Faulted,
}
